<template>
  <vue-dialog :dialog-data="dialogData">
    <el-form label-width="auto" size="small">
      <el-form-item label="生成时间：">
        <span class="content">{{row.create_at}}</span>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="厂商：">
            <span class="content">{{row.company && row.company.name || "未知"}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="型号：">
            <span class="content">{{row.model}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批次：">
            <span class="content">{{row.mac_batch_no}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="序号：">
            <span class="content">{{row.number}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授权数：">
            <span class="content">{{row.quantity}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="MAC数：">
            <span class="content">{{row.mac_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="流水号：">
            <span class="content">{{row.sequence_id}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="SN起始：">
            <span class="content">{{row.sn_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="SN结束：">
            <span class="content">{{row.sn_end}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="LAN起始：">
            <span class="content">{{row.lan_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="LAN结束：">
            <span class="content">{{row.lan_end}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="步长：">
            <span class="content">{{row.lan_step}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个数：">
            <span class="content">{{row.lan_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="WAN起始：">
            <span class="content">{{row.wan_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="WAN结束：">
            <span class="content">{{row.wan_end}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="步长：">
            <span class="content">{{row.wan_step}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个数：">
            <span class="content">{{row.wan_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="2.4G起始：">
            <span class="content">{{row.wifi2g_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="2.4G结束：">
            <span class="content">{{row.wifi2g_end}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="步长：">
            <span class="content">{{row.wifi2g_step}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个数：">
            <span class="content">{{row.wifi2g_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="5.8G起始：">
            <span class="content">{{row.wifi5g_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="5.8G结束：">
            <span class="content">{{row.wifi5g_end}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="步长：">
            <span class="content">{{row.wifi5g_step}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个数：">
            <span class="content">{{row.wifi5g_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="6G起始：">
            <span class="content">{{row.wifi6g_start}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="6G结束：">
            <span class="content">{{row.wifi6g_end}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="步长：">
            <span class="content">{{row.wifi6g_step}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个数：">
            <span class="content">{{row.wifi6g_number}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </vue-dialog>
</template>

<script>
  export default {
    name: "OrderInfo",
    props: {dialogData: Object},
    data() {
      return {
        row: this.dialogData.row || {}
      }
    }
  }
</script>

<style scoped lang="scss">
  .content {
    line-height: 32px;
    color: $home-color;
  }
</style>
